import { useEffect, useState } from "react";
import { CartConfigInterface } from "../Cart/CartTypes";
import { AvailableCartDrawerTemplates, CartItemPosition, CartItemPositions, getPixelsForCart } from "./constants";

const useCartDrawerLayoutHook = ({ config }: { config: CartConfigInterface }) => {
    const [cartGlobal, setCartGlobal] = useState({
        removeBorders: false,
    });
    const [cartFeatures, setCartFeatures] = useState({ paddingBottom: 100 });
    const [rewardLayout, setRewardLayout] = useState<{
        msgDirection: "left" | "right" | "center";
        msgSize: number;
        msgBottomMargin: number;
    }>({
        msgDirection: "center",
        msgSize: 12,
        msgBottomMargin: 12,
    });
    const [productCardLayout, setProductCardLayout] = useState<{
        pricePosition: CartItemPosition;
        deletePosition: CartItemPosition;
        discountPosition: string;
        flexDirection: "row" | "column" | "row-reverse" | "column-reverse";
        qtyRadius: number;
        qtySeparator: boolean;
    }>({
        pricePosition: CartItemPositions.BOTTOM,
        deletePosition: CartItemPositions.TOP,
        discountPosition: "under_original_price",
        flexDirection: "row",
        qtyRadius: 4,
        qtySeparator: false,
    });

    const [upsellLayout, setUpsellLayout] = useState<{
        productNaviBtnPosition: CartItemPosition;
    }>({
        productNaviBtnPosition: CartItemPositions.DEFAULT,
    });

    const [cartHeaderLayout, setCartHeaderLayout] = useState<any>({
        showIcon: false,
        showTotalItems: false,
        showUnderline: false,
        headerHeight: 30,
        closeIconSize: 20,
    });
    const [cartAdditionalLayout, setCartAdditionalLayout] = useState<any>({
        addGradientBorder: false,
        iconSize: 35,
    });
    const [cartFooterDiscountNotes, setCartFooterDiscountNotes] = useState<any>({ fontWeight: 550 });
    const [cartFooter, setCartFooter] = useState<any>({
        showComparedPrice: true,
        labelFontWeight: 550,
        fontWeight: 550,
        subFontWeight: 550,
    });
    const [billSummaryLayout, setBillSummaryLayout] = useState<any>({
        title: 550,
        labelFontWeight: 550,
        fontWeight: 550,
        subFontWeight: 550,
    });

    useEffect(() => {
        switch (config?.selected_drawer_template) {
            case AvailableCartDrawerTemplates.MODERN:
                setCartGlobal({ removeBorders: true });
                setCartFeatures({ paddingBottom: 140 });
                setCartHeaderLayout({
                    showIcon: false,
                    showTotalItems: false,
                    showUnderline: config?.show_underline_below_cart_text ?? true,
                    headerHeight: (+getPixelsForCart(config?.cart_design?.header_height, "number") + 20 + "px") as any,
                    closeIconSize: 30,
                });
                setRewardLayout({
                    msgDirection: "left",
                    msgSize: 12,
                    msgBottomMargin: 12,
                });
                setProductCardLayout({
                    pricePosition: CartItemPositions.TOP,
                    deletePosition: CartItemPositions.BOTTOM,
                    discountPosition: CartItemPositions.UNDER_QTY,
                    flexDirection: "column-reverse",
                    qtyRadius: 0,
                    qtySeparator: true,
                });
                setUpsellLayout({
                    productNaviBtnPosition: CartItemPositions.HEADER,
                });
                setCartAdditionalLayout({
                    addGradientBorder: true,
                    iconSize: 50,
                });
                setCartFooter({
                    showComparedPrice: true,
                    labelFontWeight: 450,
                    fontWeight: 450,
                    subFontWeight: 450,
                });
                setBillSummaryLayout({
                    title: 550,
                    labelFontWeight: 450,
                    fontWeight: 750,
                    subFontWeight: 450,
                });
                setCartFooterDiscountNotes({ fontWeight: 750 });
                break;
            default:
                setCartGlobal({ removeBorders: false });
                setCartFeatures({ paddingBottom: 100 });
                setCartHeaderLayout({
                    showIcon: true,
                    showTotalItems: true,
                    showUnderline: false,
                    headerHeight: getPixelsForCart(config?.cart_design?.header_height) as any,
                    closeIconSize: 20,
                });
                setRewardLayout({
                    msgDirection: "center",
                    msgSize: 12,
                    msgBottomMargin: 12,
                });

                setProductCardLayout({
                    pricePosition: CartItemPositions.BOTTOM,
                    deletePosition: CartItemPositions.TOP,
                    discountPosition: CartItemPositions.UNDER_PRICE,
                    flexDirection: "row",
                    qtyRadius: 4,
                    qtySeparator: false,
                });
                setUpsellLayout({
                    productNaviBtnPosition: CartItemPositions.DEFAULT,
                });
                setCartAdditionalLayout({
                    addGradientBorder: false,
                    iconSize: 35,
                });
                setCartFooter({
                    showComparedPrice: true,
                    labelFontWeight: 550,
                    fontWeight: 550,
                    subFontWeight: 550,
                });
                setBillSummaryLayout({
                    title: 650,
                    labelFontWeight: 550,
                    fontWeight: 550,
                    subFontWeight: 550,
                });
                setCartFooterDiscountNotes({ fontWeight: 550 });
        }
    }, [config?.selected_drawer_template, config?.show_underline_below_cart_text, config?.cart_design.header_height]);

    return {
        cartGlobal,
        cartFeatures,
        cartHeaderLayout,
        productCardLayout,
        upsellLayout,
        cartAdditionalLayout,
        cartFooterDiscountNotes,
        cartFooter,
        billSummaryLayout,
        rewardLayout,
    };
};

export default useCartDrawerLayoutHook;
